class DongerdiHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-dd-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dd-dot]'));
    this.previousButton = this.querySelector('[data-dd-previous]');
    this.nextButton = this.querySelector('[data-dd-next]');
    this.index = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.interval = Math.max(3000, Number(this.dataset.interval || 6) * 1000);
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.show(this.index - 1, true));
    this.nextButton?.addEventListener('click', () => this.show(this.index + 1, true));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.show(index, true));
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.start();
    });

    this.show(this.index, false);
    this.start();
  }

  show(nextIndex, userInitiated) {
    const total = this.slides.length;
    this.index = (nextIndex + total) % total;

    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      if ('inert' in slide) slide.inert = !active;
    });

    this.dots.forEach((dot, index) => {
      const active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (userInitiated) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (!this.autoplayEnabled || this.reducedMotion || this.slides.length < 2 || this.timer) return;
    this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
  }

  stop() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('dongerdi-hero')) {
  customElements.define('dongerdi-hero', DongerdiHero);
}
